export const white = '#ffffff';
export const whiteAlpha2 = 'rgba(255,255,255,0.02)';
export const whiteAlpha4 = 'rgba(255,255,255,0.04)';
export const whiteAlpha8 = 'rgba(255,255,255,0.08)';
export const whiteAlpha16 = 'rgba(255,255,255,0.16)';
export const whiteAlpha32 = 'rgba(255,255,255,0.32)';
export const whiteAlpha48 = 'rgba(255,255,255,0.48)';
export const whiteAlpha64 = 'rgba(255,255,255,0.64)';
export const whiteAlpha72 = 'rgba(255,255,255,0.72)';
export const black = '#0d0d0d';
export const black2 = '#fafafa';
export const black8 = '#ebebeb';
export const black16 = '#d8d8d8';
export const black32 = '#b1b1b1';
export const black48 = '#8b8b8b';
export const black64 = '#646464';
export const black72 = '#505050';
export const blackAlpha2 = 'rgba(13,13,13,0.02)';
export const blackAlpha4 = 'rgba(13,13,13,0.04)';
export const blackAlpha8 = 'rgba(13,13,13,0.08)';
export const blackAlpha16 = 'rgba(13,13,13,0.16)';
export const blackAlpha32 = 'rgba(13,13,13,0.32)';
export const blackAlpha48 = 'rgba(13,13,13,0.48)';
export const blackAlpha64 = 'rgba(13,13,13,0.64)';
export const blackAlpha72 = 'rgba(13,13,13,0.72)';
export const purple = '#4040a8';
export const purple4 = '#f8f8fc';
export const purple8 = '#f0f0f9';
export const purple16 = '#dedef2';
export const purple32 = '#bcbce6';
export const purple56 = '#8c8cd4';
export const purple72 = '#6b6bc7';
export const purpleAlpha8 = 'rgba(64,64,168,0.08)';
export const purpleAlpha16 = 'rgba(64,64,168,0.16)';
export const purpleAlpha32 = 'rgba(64,64,168,0.32)';
export const purpleAlpha56 = 'rgba(64,64,168,0.56)';
export const purpleAlpha72 = 'rgba(64,64,168,0.72)';
export const purpleDarken8 = '#343489';
export const purpleDarken16 = '#29296b';
export const blue = '#00aeef';
export const blue8 = '#ebfaff';
export const blue16 = '#d6f4ff';
export const blue32 = '#a8e8ff';
export const blue56 = '#66d6ff';
export const blue72 = '#3dcbff';
export const blueAlpha8 = 'rgba(0,174,239,0.08)';
export const blueAlpha16 = 'rgba(0,174,239,0.16)';
export const blueAlpha32 = 'rgba(0,174,239,0.32)';
export const blueAlpha56 = 'rgba(0,174,239,0.56)';
export const blueAlpha72 = 'rgba(0,174,239,0.72)';
export const blueDarken8 = '#0092c7';
export const blueDarken16 = '#00749e';
export const yellow = '#ffd140';
export const yellow8 = '#fffbf0';
export const yellow16 = '#fff8e0';
export const yellow32 = '#fff1c2';
export const yellow56 = '#fbdc8d';
export const yellow72 = '#ffdf75';
export const yellowAlpha8 = 'rgba(255,209,64,0.08)';
export const yellowAlpha16 = 'rgba(255,209,64,0.16)';
export const yellowAlpha32 = 'rgba(255,209,64,0.32)';
export const yellowAlpha56 = 'rgba(255,209,64,0.56)';
export const yellowAlpha72 = 'rgba(255,209,64,0.72)';
export const yellowDarken8 = '#ffc91a';
export const yellowDarken16 = '#f0b800';
export const red = '#db2642';
export const red8 = '#fceef0';
export const red16 = '#f9dce0';
export const red32 = '#f4b8c1';
export const red56 = '#eb8494';
export const red72 = '#e56175';
export const redAlpha8 = 'rgba(219,38,66,0.08)';
export const redAlpha16 = 'rgba(219,38,66,0.16)';
export const redAlpha32 = 'rgba(219,38,66,0.32)';
export const redAlpha56 = 'rgba(219,38,66,0.56)';
export const redAlpha72 = 'rgba(219,38,66,0.72)';
export const redDarken8 = '#b81e35';
export const redDarken16 = '#95182b';
export const green = '#00a04f';
export const green8 = '#e7f9f0';
export const green16 = '#d2f4e3';
export const green32 = '#a5e9c7';
export const green56 = '#60d79c';
export const green72 = '#33cc80';
export const greenAlpha8 = 'rgba(0,160,79,0.08)';
export const greenAlpha16 = 'rgba(0,160,79,0.16)';
export const greenAlpha32 = 'rgba(0,160,79,0.32)';
export const greenAlpha56 = 'rgba(0,160,79,0.56)';
export const greenAlpha72 = 'rgba(0,160,79,0.72)';
export const greenDarken8 = '#00753b';
export const greenDarken16 = '#004d26';
export const primary = purple;
export const primary8 = purple8;
export const primary16 = purple16;
export const primary32 = purple32;
export const primary56 = purple56;
export const primary72 = purple72;
export const primaryAlpha8 = purpleAlpha8;
export const primaryAlpha16 = purpleAlpha16;
export const primaryAlpha32 = purpleAlpha32;
export const primaryAlpha56 = purpleAlpha56;
export const primaryAlpha72 = purpleAlpha72;
export const primaryDarken8 = purpleDarken8;
export const primaryDarken16 = purpleDarken16;